import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import Iconify from '../iconify';
import { useGetPickem } from '@/api/pickems/getPickem.ts';
import { PrizesBreakdown } from '@/@types/api.types.ts';
import { AnyFieldApi } from '@tanstack/react-form';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';

interface EditPrizeSettingsProps {
  form: any;
}

export const EditPrizeSettings = ({ form }: EditPrizeSettingsProps) => {
  const { pickemId } = useAppSearchParams();
  const { isLoading } = useGetPickem(pickemId);

  const addPrizeLevelHandler = () => {
    form.setFieldValue('prizesBreakdown', (value: PrizesBreakdown[]) => {
      value.push({
        placeStart: value.length + 1,
        placeEnd: value.length + 1,
        prizeText: '',
        prizeValue: 100,
      });
      return value;
    });
  };

  const removePrizeLevelHandler = (index: number) => {
    form.setFieldValue('prizesBreakdown', (value: any[]) => {
      value.splice(index, 1);
      return value;
    });
  };

  if (isLoading) {
    return (
      <Card sx={{ padding: 4 }}>
        <Box
          sx={{ display: 'flex', justifyContent: 'center' }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      </Card>
    );
  }

  return (
    <Card sx={{ padding: 4 }}>
      <Grid container spacing={3}>
        <form.Field
          name='prizesBreakdown'
          children={({ state }: AnyFieldApi) => {
            return state.value.map((_prize: any, index: number) => (
              <Grid item xs={12} key={`prize-${index}`}>
                <Grid container spacing={3}>
                  <Grid item xs={2}>
                    <form.Field
                      name={`prizesBreakdown[${index}].placeStart`}
                      children={({ state, handleChange, handleBlur }: any) => (
                        <TextField
                          label='Start Place'
                          fullWidth
                          variant='standard'
                          value={state.value}
                          onChange={(e) => handleChange(e.target.value)}
                          onBlur={handleBlur}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <form.Field
                      name={`prizesBreakdown[${index}].placeEnd`}
                      children={({ state, handleChange, handleBlur }: any) => (
                        <TextField
                          label='End Place'
                          fullWidth
                          variant='standard'
                          value={state.value}
                          onChange={(e) => handleChange(e.target.value)}
                          onBlur={handleBlur}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1} sx={{ pt: 4 }}></Grid>
                  <Grid item xs={4}>
                    <form.Field
                      name={`prizesBreakdown[${index}].prizeText`}
                      children={({ state, handleChange, handleBlur }: any) => (
                        <TextField
                          label={`Prize Text ${index}`}
                          fullWidth
                          variant='standard'
                          value={state.value}
                          onChange={(e) => handleChange(e.target.value)}
                          onBlur={handleBlur}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <form.Field
                      name={`prizesBreakdown[${index}].prizeValue`}
                      children={({ state, handleChange, handleBlur }: any) => (
                        <TextField
                          label='Cash Prize Value'
                          fullWidth
                          variant='standard'
                          value={state.value}
                          onChange={(e) => handleChange(e.target.value)}
                          onBlur={handleBlur}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={1}>
                    <IconButton
                      color='primary'
                      aria-label='upload picture'
                      component='label'
                      onClick={() => removePrizeLevelHandler(index)}
                    >
                      <Iconify icon={'eva:trash-2-outline'} />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            ));
          }}
        />

        <Grid item xs={12}>
          <Button
            variant='outlined'
            startIcon={<Iconify icon='eva:plus-circle-outline' />}
            onClick={() => addPrizeLevelHandler()}
            sx={{ mr: 2 }}
          >
            Add Prize Level
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};
